import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "5", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "19", x2: "22", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "2", y2: "5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "19", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Locate";
const Locate = memo(themed(Icon));
export {
  Locate
};
//# sourceMappingURL=locate.js.map
